import React from 'react';
import { useTranslation } from 'react-i18next';

function DeleteElectionModal({ show, onHide, onConfirm, electionTitle, loading }) {
    const { t } = useTranslation(['modal', 'common']);

    const handleConfirm = () => {
        if (!loading) {
            onConfirm();
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            onHide();
        } else if (e.key === 'Enter' && !loading) {
            handleConfirm();
        }
    };

    if (!show) return null;

    return (
        <div
            className="modal show d-block"
            tabIndex="-1"
            style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
            onKeyDown={handleKeyDown}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{t('modal:deleteElection.title')}</h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onHide}
                            disabled={loading}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="alert alert-danger">
                            <strong>{t('modal:deleteElection.alert.title')}</strong>
                        </div>

                        <p dangerouslySetInnerHTML={{ __html: t('modal:deleteElection.description', { electionTitle }) }} />

                        <div className="delete-warnings bg-light p-3 rounded">
                            <div className="mb-2">
                                <strong>⚠️ {t('modal:deleteElection.warnings.permanent')}</strong>
                            </div>
                            <div>
                                <strong>⚠️ {t('modal:deleteElection.warnings.allData')}</strong>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={onHide}
                            disabled={loading}
                        >
                            {t('modal:deleteElection.buttons.cancel')}
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={handleConfirm}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                    {t('modal:deleteElection.buttons.deleting')}
                                </>
                            ) : (
                                t('modal:deleteElection.buttons.delete')
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeleteElectionModal;
